module.exports = __webpack_public_path__ + "img/kelvin.90786121.png";